// extracted by mini-css-extract-plugin
export default {"def-error-text":"styles_def-error-text__GbYVN","margin-top4":"styles_margin-top4__AfVKm","width12":"styles_width12__PglgI","width16":"styles_width16__69exa"};